import store from '@/store';

export let adminGuard = (to, from, next) => {

	if (store.state.auth.isAppAdmin)
		return next();
	else{
		return next("*");
	}

	
}

export let isAppAdmin = () => {
	return store.state.auth.isAppAdmin;
}